import React from 'react';
import Button from '../Button';
import CancelButton from '../CancelButton';

import ModalButtonsStyles from './ModalButtons.module.css';

const ModalButtons = ({ submitButtonLabel, onSubmit, cancelButtonLabel, onCancel, style }) => {
	return (
		<div className={ModalButtonsStyles.buttons} style={style}>
			{submitButtonLabel && (
				<Button
					label={submitButtonLabel}
					onClick={(e) => {
						e.preventDefault();
						onSubmit();
					}}
				/>
			)}
			{cancelButtonLabel && (
				<CancelButton
					label={cancelButtonLabel}
					onClick={(e) => {
						e.preventDefault();
						onCancel();
					}}
				/>
			)}
		</div>
	);
};

export default ModalButtons;
